var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16662_84098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25781 23.1824L7.20245 28L10.758 25.3886C11.0841 25.149 11.4769 25.0213 11.8814 25.0199C14.4241 25.0089 17.0485 24.8915 19.7313 24.6979C20.2572 24.6601 20.777 24.5434 21.2673 24.349C24.6251 23.0155 27.1424 21.2893 29.2106 19.3529C29.4722 19.1084 29.6604 18.7898 29.7263 18.4376C29.9041 17.4797 29.0959 17.249 27.6169 17.5126C26.7345 17.6699 25.9091 18.0462 25.1813 18.5694C24.0716 19.3659 22.5706 20.0258 20.661 20.5429C20.2346 20.6582 19.7937 20.7262 19.3522 20.7427C18.1094 20.788 16.9764 20.7317 16.0192 20.512C15.875 20.479 15.8619 20.2778 15.9993 20.2229L19.8809 18.6813C21.509 18.0029 21.5907 15.8942 20.2881 15.8228C20.1693 15.8159 20.0519 15.8338 19.9359 15.8592C17.1652 16.473 13.1221 16.8974 8.64718 17.2565C7.7662 17.3272 6.93465 17.6912 6.28713 18.2927C4.96394 19.5211 3.61465 21.2797 2.25781 23.1824Z",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5254 6.92342L25.9471 7.1027M28.4737 7.20514L25.9471 7.1027L28.4737 7.20514ZM16.3332 6.7129C16.3112 7.36104 16.1613 7.99844 15.892 8.5884C15.6228 9.17836 15.2394 9.70922 14.7641 10.1504C14.2889 10.5916 13.731 10.9345 13.1227 11.1592C12.5143 11.3839 11.8675 11.4861 11.2196 11.4598C10.5716 11.4335 9.93521 11.2793 9.34707 11.0061C8.75893 10.7329 8.23064 10.346 7.79263 9.86777C7.35462 9.38954 7.01553 8.82938 6.7949 8.21956C6.57426 7.60973 6.47643 6.96229 6.50705 6.3145C6.58166 5.02734 7.15884 3.82097 8.11427 2.95523C9.06971 2.0895 10.327 1.63365 11.6152 1.68589C12.9035 1.73812 14.1197 2.29425 15.0019 3.23449C15.8841 4.17474 16.3617 5.42387 16.3319 6.71285L16.3332 6.7129ZM16.3332 6.7129L21.5254 6.92342L16.3332 6.7129ZM21.5254 6.92342L21.3718 10.7134L25.7934 10.8927L25.9471 7.1027L21.5254 6.92342Z",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16662_84098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessIcon);
export default __webpack_public_path__ + "static/media/access-icon.d1026b62.svg";
export { ForwardRef as ReactComponent };